import React from "react"

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  HashRouter
} from "react-router-dom";

import Pending from '../Redeem/Pending_Redeem';
import History from '../Redeem/History_Redeem';
import Request from '../Redeem/RequestRedeem';
import { REDEEMPAGE_STRINGS } from '../Strings';

class Request_Redeem extends React.Component {
  render() {
    return (
      <div className="w-100 pa2 tc" style={{ backgroundColor: '#00214a', minHeight: '100vh' }}>
        <div className="ph2 mt3 ph3 mt2-m  db center tc ">
          <div className="db  ">
            <Router> 
            {/* <HashRouter> */}
            {/*  */}
              <Link className="w-33 f4-l f6-m f5-ns bl br b--black-10 pointer dib link tc pv2 bg-gray white" to="/">{REDEEMPAGE_STRINGS.KEY_REQUEST}</Link>
              <Link className="w-34 f4-l f6-m f5-ns bl br b--black-10 pointer dib link tc pv2 bg-gray white" to="/Pending">{REDEEMPAGE_STRINGS.KEY_PENDING}</Link>
              <Link className="w-33 f4-l f6-m f5-ns pointer dib link tc pv2 bg-gray white" to="/History">{REDEEMPAGE_STRINGS.KEY_HISTORY}</Link>
              <Switch>
                <Route exact path="/" component={Request} />
                <Route path="/Pending" component={Pending} />
                <Route path="/History" component={History} />
              </Switch>
            {/* </HashRouter> */}
            </Router> 
          </div>
        </div>
      </div>
    )
  }

}
export default Request_Redeem;